import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NavigationNode } from '@spartacus/storefront';
import { NavLabelComponent } from '../nav-label/nav-label.component';
import { Content3LevelsComponent } from './content-3-levels/content-3-levels.component';
import { Content4LevelsComponent } from './content-4-levels/content-4-levels.component';
import { Content2LevelsComponent } from './content-2-levels/content-2-levels.component';

@Component({
  selector: 'menu-desktop',
  standalone: true,
  imports: [CommonModule, Content2LevelsComponent, Content3LevelsComponent, Content4LevelsComponent, NavLabelComponent],
  templateUrl: './menu-desktop.component.html',
  styleUrl: './menu-desktop.component.scss',
})
export class MenuDesktopComponent {
  @Input() node!: NavigationNode;

  qtyLevels(node: NavigationNode): number {
    if (!node.children || node.children.length === 0) {
      return 1;
    }

    const childDepths = node.children.map(child => this.qtyLevels(child));
    return Math.max(...childDepths) + 1;
  }
}
